import BlogPage from "../../../components/Blog/Blog";

const Blog: React.FC = () => {
  return <BlogPage />;
};

export default Blog;
